module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "prepare"
    }
  }, [_c('contentMenu'), _vm._v(" "), _c('prepareContent'), _vm._v(" "), _c('contentFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64d07e7b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Prepare.vue
// module id = 76
// module chunks = 0